export const END_OF_VIDEO_LINK_TRACKING_NAME = 'sfc_end_of_video_lecture_link';
